import React, { Component } from 'react';
import FilterBasic from '../../../basicElement/FilterBasic';
import API_URL from '../../../../common/url';

class Filter extends Component {
    render() {
        const { 
            areaList,
            typeList,
            businessList,
            MedicineTypeList,
            departmentList,
            byStageList,
            listCollection,
            ...rest
        } = this.props;
        const departmentOption = departmentList.map(i => ({ label: i.enterpriseDepartmentName, value: i.enterpriseDepartmentId }));
        //业务线
        const businessOption = (listCollection.find( el =>  el.responsibleFieldName == '业务线') || {businessLineList:[]}).businessLineList.map(i => ({ label: i.businessLineName, value: i.businessLineId }));
        //项目领域
        const areaListOption = (listCollection.find( el =>  el.responsibleFieldName == '项目领域') || {investigationAreaList:[]}).investigationAreaList.map(i => ({ label: i.investigationAreaName, value: i.investigationAreaId }));
        //项目分类
        const typeOption = (listCollection.find( el =>  el.responsibleFieldName == '项目分类') || {projectCategoryList:[]}).projectCategoryList.map(i => ({ label: i.projectCategoryName, value: i.projectCategoryId }));
        // 研究产品类型
        const medicineTypeOptions = (listCollection.find( el =>  el.responsibleFieldName == '研究产品类型') || {researchProductTypeList:[]}).researchProductTypeList.map(i => ({ label: i.researchProductTypeName, value: i.researchProductTypeId }));
        //项目分期
        const byStageOption = (listCollection.find( el =>  el.responsibleFieldName == '项目分期') || {projectStagingList:[]}).projectStagingList.map(i => ({ label: i.projectStagingName, value: i.projectStagingId }));

        const filters = [{
            name: '领域leader',
            key: 'user',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 160},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.user.queryLeaderList,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }, {
            name: '部门',
            key: 'enterpriseDepartmentId',
            type: 'select',
            typeProperty: {
                style: {width: 160},
                list: departmentOption,
            }
        }, {
            name: '业务线',
            key: 'businessLineId',
            type: 'select',
            typeProperty: {
                style: {width: 120},
                list: businessOption,
            }
        }, {
            name: '项目领域',
            key: 'investigationAreaId',
            type: 'select',
            typeProperty: {
                style: {width: 120},
                list: areaListOption,
            }
        }, {
            name: '项目分类',
            key: 'projectCategoryId',
            type: 'select',
            typeProperty: {
                style: {width: 120},
                list: typeOption,
            }
        }, {
            name: '研究产品类型',
            key: 'researchProductTypeId',
            type: 'select',
            typeProperty: {
                style: {width: 120},
                list: medicineTypeOptions,
            }
        }, {
            name: '项目分期',
            key: 'projectStagingId',
            type: 'select',
            typeProperty: {
                style: {width: 120},
                list: byStageOption,
            }
        }
    ];
        return (
            <FilterBasic filters={filters} {...rest} />
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/user/fieldLeader/components/Filter.js